<template>
  <div>
    <div v-if="!$store.getters.isKiosk" class="myHead">
      <v-app-bar style="background: transparent; height: 67px;" dark>

        <!--        <v-toolbar style="background: transparent; height: 67px; padding-top: 2px" dark>-->
        <v-btn v-if="!isHome" icon @click.native.passive="goBack" style="flex-grow: 0;">
          <v-icon medium class="myBlack">mdi-chevron-left</v-icon>
        </v-btn>
        <v-btn v-if="isHome" icon @click.native.passive="menuClicked" style="flex-grow: 0;">
          <v-icon medium class="myBlack">mdi-menu</v-icon>
        </v-btn>

        <div class="d-inline-block text-left pl-1 flex-shrink-1 flex-grow-0 overflow-hidden titleFont pointer"
             @click.passive="gotoHome">
          <img style="height: 60px;margin-top: 3px;" class="mr-2 sharpImage" src="../assets/Filati-logo.png">
          </div>

<!--        <div class="prelative">-->
<!--          <Search></Search>-->
<!--        </div>-->

        <div></div>

        <div class="text-right headIcons" style="flex-shrink: 0">
          <v-btn class="rounded100" icon @click.native.passive="gotoHome">
            <img class="dotImg" src="../assets/icons/wollknaul.png" style="transform: scale(1.6)">
            <!--            <v-icon medium class="myBlack">mdi-home</v-icon>-->
          </v-btn>
          <v-btn class="rounded100" icon v-if="$store.getters.inhouse && $store.state.enableKellnerruf"
                 @click.native.passive="goKellnerruf">
            <img class="dotImg soloInvert" src="../assets/icons/waiter.png">
            <!--                    <v-icon medium class="myBlack">mdi-room-service</v-icon>-->
          </v-btn>
          <v-btn icon class="hidden-xs-only rounded100"
                 v-if="$store.state.enableNews"
                 @click.native.passive="gotoAktuelles">
            <v-icon medium class="myBlack">mdi-alert-decagram</v-icon>
          </v-btn>
          <v-btn icon class="hidden-sm-and-down rounded100" @click.native.passive="goLastOrders">
            <v-icon medium class="myBlack">mdi-history</v-icon>
          </v-btn>

          <!--                <v-btn icon @click.native.passive="gotoSortiment" >-->
          <!--                    <v-icon medium>mdi-silverware-fork-knife</v-icon>-->
          <!--                </v-btn>-->

          <v-badge
            v-if="itemsCount > 0"
            color="#000000"
            :content="itemsCount"
            overlap
            offset-x="20"
            offset-y="20"
            class="cart animated"
          >
            <v-btn class="rounded100" icon @click.native.passive="gotoCart">
              <v-icon medium class="myBlack">mdi-cart</v-icon>
            </v-btn>
          </v-badge>
          <v-btn class="rounded100" icon v-else @click.native.passive="gotoCart">
            <v-icon medium class="myBlack">mdi-cart</v-icon>
          </v-btn>

          </div>


        <!--        </v-toolbar>-->
      </v-app-bar>

      <install v-if="!$store.getters.inhouse && $store.state.showInstallPwa"></install>
    </div>

    <div v-else-if="!$store.getters.showKioskSplashOnHome" class="myHead kiosk">
      <v-app-bar style="background: transparent; height: 67px;" dark>

        <v-btn v-if="!isHome" icon @click.native.passive="goBack" style="flex-grow: 0;">
          <v-icon medium class="myWhite">mdi-chevron-left</v-icon>
        </v-btn>

        <div class="d-inline-block text-left pl-1 flex-shrink-1 overflow-hidden titleFont pointer" @click.passive="gotoHome">
          <img style="height: 50px;margin-top: 5px;" class="mr-2 sharpImage" src="../assets/placeholder6-opti.png">
        </div>

        <div class="text-right headIcons" style="flex-shrink: 0">

          <div class="mr-15 d-inline-block">
            <TripleClick @triple-click="onTripleClickSetup">
              <div style="border: 1px solid red; color: red; padding: 2px 15px" class="noselect"
                   :class="{invisible: $store.getters.hideSetupButton}"
              >
                SETUP
              </div>
            </TripleClick>
          </div>

          <v-btn class="rounded100" icon @click.native.passive="gotoHome">
            <v-icon medium class="myWhite">mdi-home</v-icon>
          </v-btn>
          <!--          <v-btn class="rounded100" icon v-if="$store.getters.inhouse && $store.state.enableKellnerruf"-->
          <!--                 @click.native.passive="goKellnerruf">-->
          <!--            <img class="dotImg soloInvert" src="../assets/icons/waiter.png">-->
          <!--            &lt;!&ndash;                    <v-icon medium class="myWhite">mdi-room-service</v-icon>&ndash;&gt;-->
          <!--          </v-btn>-->
          <v-btn icon class="hidden-xs-only rounded100"
                 v-if="$store.state.enableNews"
                 @click.native.passive="gotoAktuelles">
            <v-icon medium class="myWhite">mdi-alert-decagram</v-icon>
          </v-btn>
          <v-btn icon @click.native.passive="gotoFoods">
            <v-icon medium class="myWhite">mdi-silverware-fork-knife</v-icon>
          </v-btn>
          <v-btn icon @click.native.passive="gotoDrinks">
            <v-icon medium class="myWhite">mdi-beer</v-icon>
          </v-btn>
          <!--          <v-btn icon class="hidden-sm-and-down rounded100" @click.native.passive="goLastOrders">-->
          <!--            <v-icon medium class="myWhite">mdi-history</v-icon>-->
          <!--          </v-btn>-->

          <v-badge
            v-if="itemsCount > 0"
            color="#000000"
            :content="itemsCount"
            overlap
            offset-x="20"
            offset-y="20"
            class="cart animated"
          >
            <v-btn class="rounded100" icon @click.native.passive="gotoCart">
              <v-icon medium class="myWhite">mdi-cart</v-icon>
            </v-btn>
          </v-badge>
          <v-btn class="rounded100" icon v-else @click.native.passive="gotoCart">
            <v-icon medium class="myWhite">mdi-cart</v-icon>
          </v-btn>
        </div>
      </v-app-bar>
    </div>

    </div>
  </div>
</template>

<script>
import store from '../store/store'
import {ebus} from '../vendor/ebus';
// import * as firebaseUtil from '../firebase/firebaseUtil';
import * as bootstrap from '../vendor/bootstrap'
import * as util from "@/vendor/util";
import Install from "./install";
import TripleClick from "../kiosk/TripokeClick.vue";
import Search from "../search/Search.vue";
import Vue from "vue";

export default {
  components: {TripleClick, Install, Search},
  Name: "AppHead",
  // computed: {
  //     hasFavs() {
  //         return store.getters.favFoods.length > 0;
  //     }
  // },
  // data() {
  //     return {
  //     }
  // },
  created() {
    ebus.$on('itemAdded', () => {
      this.anim();
    });
  },
  computed: {
    Vue() {
      return Vue
    },
    isHome() {
      return this.$route.name === 'Home' ||
        (this.$route.name === 'Sortiment' && store.getters.inhouse);
    },
    page() {
      let p = store.getters.page;
      let rn = '';
      if (p.length > 2) {
        rn = p;// p.substring(store.state.brandName.length + 3, p.length);
      } else {
        rn = this.$route.name;
      }
      if (!rn || rn === 'all') {
        rn = store.state.brandName;
      }
      return rn;
    },
    numberOfFavs() {
      return 0;
      // let favFoods = [];
      // let favs = cloneMe(store.getters.favFoods);
      // for (let favFood of favs) {
      //     let foodItem;
      //     if (favFood.type && favFood.type === 'drink') {
      //         favFood = store.getters.getDrinkById(favFood.id);
      //     } else {
      //         favFood = store.getters.getFoodById(favFood.id);
      //     }
      //
      //     if (!foodItem) {
      //         //ignore items that do not exist
      //         continue;
      //     }
      //     // if ('image' in foodItem) {
      //     //     favFood.image = foodItem.image;
      //     // }
      //     favFoods.push(favFood);
      // }
      // // if (favFoods.length === 0) {
      // let lsFavFoods = this.$ls.get('favFoods');
      // if (lsFavFoods) {
      //     let fv = lsFavFoods;
      //     for (let v of fv) {
      //         //ignore items that already exist
      //         if (this.containsItemId(favFoods, v.id)) {
      //             continue
      //         }
      //
      //         let foodItem;
      //         if (v.type && v.type === 'drink') {
      //             foodItem = store.getters.getDrinkById(v.id);
      //         } else {
      //             foodItem = store.getters.getFoodById(v.id);
      //         }
      //
      //         if (!foodItem) {
      //             //ignore items that do not exist
      //             continue;
      //         }
      //         // if ('image' in foodItem) {
      //         //     v.image = foodItem.image;
      //         // }
      //         favFoods.push(v);
      //     }
      // }
      // let result = favFoods.length;
      // store.commit('numberOfFavs', result);
      // return result;
    },
    hasAccount() {
      return bootstrap.hasAccount();
    },
    // unreadNews() {
    //     return store.getters.unreadNews;
    // },
    itemsCount() {
      let i = 0;
      for (let item of store.getters.cartItems) {
        if (item.id.startsWith('special') || item.id.startsWith('stempel-')) {
          continue;
        }
        i += item.count;
      }
      return '' + i;
    },
  },
  methods: {
    onTripleClickSetup() {
      this.$router.push({name: 'SetupKiosk'});
    },
    goBack() {
      if (this.$route.name === 'Bestellung') {
        this.$router.push({name: 'Home'});
      } else {
        ebus.$emit('goBack');
      }
    },
    containsItemId(items, id) {
      for (let item of items) {
        if (item.id === id) {
          return true;
        }
      }
      return false;
    },
    clickContact() {
      ebus.$emit('triggerFeedback');
    },
    clickSortiment() {
      this.$router.push({name: 'Sortiment'});
    },
    goCoupons() {
      this.$router.push({name: 'Coupons'});
    },
    // goFilialen() {
    //     this.$router.push({name: 'Filialen'});
    // },
    gotoCart() {
      if (this.$route.name === 'Korb') {
        ebus.$emit('toast', 'Du befindest dich bereits im Warenkorb');
      } else {
        this.$router.push({name: 'Korb'});
      }

    },
    gotoSettings() {
      this.$router.push({name: 'Einstellungen'});
    },
    // gotoNews() {
    //     this.$router.push({name: 'Aktuelles'});
    // },
    install() {
      ebus.$emit('installPrompt')
    },
    goAccount() {
      this.$router.push({name: 'Account'});
    },
    signin() {
      this.$router.push({name: 'Anmelden'});
    },
    register() {
      this.$router.push({name: 'Registrierung'});
    },
    share() {
      ebus.$emit('shareApp');
    },
    gotoOeffnungszeiten() {
      this.$router.push({name: 'Oeffnungszeiten'});
    },
    gotoAbholzeiten() {
      this.$router.push({name: 'Abholzeiten'});
    },
    gotoAktuelles() {
      this.$router.push({name: 'Aktuelles'});
    },
    goLastOrders() {
      this.$router.push({name: 'Bestellungen'});
    },
    gotoCheckin() {
      // if (bootstrap.isAndroid) {
      //     ebus.$emit('showInfo', {
      //         title: 'Diese Funktion befindet sich in Arbeit. Bitte manuell registrieren!',
      //         // text: 'Bitte wähle eine Option aus für "' + _variant.title + '"',
      //     });
      // } else {
      //     this.$router.push({name: 'Checkin'});
      // }
    },
    gotoTischreservierung() {
      this.$router.push({name: 'Tischreservierung'});
    },
    // gotoImpressum(){
    //     this.$router.push({name: 'Impressum'});
    // },
    // clickDots() {
    // if (!firebaseUtil.getPushToken()) {
    //     ebus.$emit('showQuestion', {
    //         quest: 'Möchtest du über Statusänderungen zu deiner Bestellung benachrichtigt werden?',
    //         yesAction: 'requestPush',
    //         yesLabel: 'Ja, Zulassen'
    //     })
    // }
    // },
    triggerSearch() {
      ebus.$emit('triggerSearchAnywhere')
    },
    goKellnerruf() {
      this.$router.push({name: 'Kellnerruf'});
    },
    gotoHome() {
      if (this.$route.name === 'Home') {
        if (!store.getters.isKiosk) {
          ebus.$emit('toast', 'Du befindest dich bereits auf der Startseite');
        }
        setTimeout(() => {
          util.jumpToTop()
        }, 140);
        // alert('has fully = '+!!window.fully);
      } else {
        this.$router.push({name: 'Home'});
      }
    },
    gotoSortiment() {
      this.$router.push({name: 'Sortiment'});
    },
    gotoFoods() {
      ebus.$emit('shortcutToFoodMenu');
      // this.$router.push({name: 'Speisen'});
    },
    gotoDrinks() {
      ebus.$emit('shortcutToDrinkMenu');
      // this.$router.push({name: 'Getraenke'});
    },
    gotoFavs() {
      this.$router.push({name: 'Favoriten'});
    },
    cancleSearch() {
      ebus.$emit('cancleSearch')
    },

    menuClicked() {
      this.$emit('menu');
    },

    anim() {
      console.log('??? trigger animation now');
      try {
        setTimeout(() => {
          let theCart = document.querySelector('.cart.animated .v-badge__badge');
          this.doTriggerAnimation(theCart);
        }, 50);
      } catch (err) {
        console.log('Error in animation: ' + err);
      }
    },

    doTriggerAnimation(elem) {
      if (elem) {
        elem.classList.remove('cartanimation');
        elem.classList.add('cartanimation');
        setTimeout(() => {
          elem.classList.remove('cartanimation');
        }, 3050);
      }
    },

  }
}
</script>

<style lang="scss" scoped>
@import '../styles/base';

.cart ::v-deep .v-badge__badge {
  color: white;
  font-weight: bolder;
}

.dotImg {
  width: 24px;
  height: auto;
  /*display: inline-flex;*/
  /*vertical-align: middle;*/
}

.headIcons {
  ::before {
    font-size: 30px;
  }
}

/*.headIcons ::v-deep i{*/
/*    color: #809AA2 !important;*/
/*}*/
/*.headLeft {*/
/*    color: #808080 !important;*/
/*}*/


.myHead {
  position: fixed;
  z-index: 190;
  top: 0;
  left: 0;
  width: 100%;
  height: $headHeight;
  background-color: rgba(255, 255, 255, 0.2);
  //background-color: rgba($color-darkblue, 0.9);
  //backdrop-filter: blur(5px);
  box-shadow: none;
  //@include material-shadow(1);
  /*border-bottom: 1px solid #82ACB7;*/
  backdrop-filter: blur(10px); //glass-effect
}

.myHead ::v-deep .v-toolbar__content > * {
  flex-grow: 1;
}

.myHead ::v-deep header {
  overflow: hidden;
}

/*.tablet {*/
/*    .myHead {*/
/*        //background-color: rgba($color-primary, 0.9);*/
/*        //backdrop-filter: blur(5px);*/
/*    }*/
/*}*/

.dotMenu ::v-deep .v-list-item__title {
  font-size: 1.2em;
}

.onliner {
  font-size: 14px;
  font-size: min(max(12px, 2.8vw), 18px);
}

.v-toolbar__title {
  font-weight: 700;
}


</style>
